import apiSlice from "./apiSlice";

const issuesDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        
        // Get Issues KPI
        getIssuesKPI: builder.query({
            query: (params) => ({
                url: `issues/dashboard/issue-kpis`,
                params
            }),
            providesTags: ["Get-Issues-KPI"],
        }),

        // Get Issues Time Impact List
        getIssuesTimeImpact: builder.query({
            query: (params) => ({
                url: `issues/dashboard/module-time-impact`,
                params
            }),
            providesTags: ["Get-Issues-Time-Impact"],
        }),

        // Get Issues Cost Impact List
        getIssuesCostImpact: builder.query({
            query: (params) => ({
                url: `issues/dashboard/module-cost-impact`,
                params
            }),
            providesTags: ["Get-Issues-Cost-Impact"],
        }),

        // Get Issues Distribution Module Graph
        getIssuesDistributionModule: builder.query({
            query: (params) => ({
                url: `issues/dashboard/module-group-count`,
                params
            }),
            providesTags: ["Get-Issues-Distribution-Module-Graph"],
        }),

        // Get Open Issues Distribution Severity Graph
        getOpenIssuesDistributionSeverity: builder.query({
            query: (params) => ({
                url: `issues/dashboard/severity-group-count`,
                params
            }),
            providesTags: ["Get-Open-Issues-Distribution-Severity-Graph"],
        }),

        // Get Issues Ageing Analysis Graph
        getIssuesAgeingAnalysis: builder.query({
            query: (params) => ({
                url: `issues/dashboard/ageing-analysis`,
                params
            }),
            providesTags: ["Get-Issues-Ageing-Analysis-Graph"],
        }),

        // Get All Issues Listing
        getAllIssuesListing: builder.query({
            query: (params) => ({
                url: `issues`,
                params
            }),
            providesTags: ["Get-All-Issues-Listing"],
        }),

        // Get All Issues Graph Click
        getAllIssuesOpenClose: builder.query({
            query: (params) => ({
                url: `issues/filter`,
                params
            }),
            providesTags: ["Get-All-Issues-Graph-Click"],
        }),

    }),
});

export default issuesDashboardSlice;

export const {
    useGetIssuesKPIQuery, useGetIssuesTimeImpactQuery, useGetIssuesCostImpactQuery, useGetIssuesDistributionModuleQuery, 
    useGetOpenIssuesDistributionSeverityQuery, useGetIssuesAgeingAnalysisQuery, useGetAllIssuesListingQuery,
    useGetAllIssuesOpenCloseQuery, 
} = issuesDashboardSlice;